// extracted by mini-css-extract-plugin
module.exports = {"movieRelatedSlider":"RelatedMoviesView_movieRelatedSlider__2sTlB","movieRelatedSlide":"RelatedMoviesView_movieRelatedSlide__4L9pv"};